import SafetyAPI from '@/services/api/safety'

const safetyMsds = {
	namespaced: true,
	state: {
		msdsList: {},
		count: undefined,
		unsafeCount: undefined,
		offset: 0,
		limit: 10,
		sortType: 1,
		status: [],
		order: ['STATUS'],
		orderDirection: ['DESC'],
	},
	getters: {
		getMsdsList: state => state.msdsList,
	},
	mutations: {
		setMsdsList: (state, payload) => {
			state.msdsList = payload
		},
		addMsdsList: (state, payload) => {
			state.msdsList = [...state.msdsList, ...payload]
		},
		setOffset: (state, payload) => {
			state.offset = payload
		},
		setOrder: (state, payload) => {
			state.order = payload
		},
		setOrderDirection: (state, payload) => {
			state.orderDirection = payload
		},
		setMsdsSortType: (state, payload) => {
			state.sortType = payload
			switch (payload) {
				case 1:
					state.order = ['STATUS']
					state.orderDirection = ['DESC']
					break
				case 2:
				case 3:
					state.order = ['NAME']
					state.orderDirection = ['ASC']
					break
			}
		},
		setMsdsListCount: (state, payload) => {
			state.count = payload
		},
		setUnsafeCount: (state, payload) => {
			state.unsafeCount = payload
		},
	},
	actions: {
		lookupMsdsList: async ({ commit }, payload) => {
			const { instId, status } = payload
			const msds = safetyMsds.state
			// commit('setOffset', 0)
			const response = await SafetyAPI.lookupMsdsList(
				instId,
				msds.offset,
				msds.limit,
				msds.order,
				msds.orderDirection,
				msds.keyword,
				status
			)

			if (status == 'UNSAFE') {
				commit('setUnsafeCount', response.data.count)
			} else {
				commit('setMsdsListCount', response.data.count)
				commit('setMsdsList', response.data.list)
			}
		},
		addMsdsList: async ({ commit }, payload) => {
			const { instId, status } = payload
			const msds = safetyMsds.state
			const response = await SafetyAPI.lookupMsdsList(
				instId,
				msds.offset,
				msds.limit,
				msds.order,
				msds.orderDirection,
				msds.keyword,
				status
			)
			commit('addMsdsList', response.data.list)
		},
	},
}

export default safetyMsds
